<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
}
</script>

<style>
html, body, #app {
  height: 100%;
}
#app > div {
  height: 100%;
}
.error {
  color: red;
}
</style>
